import React from 'react';
import LoginScreen from '@/components/auth/LoginScreen';

const PARTNER_BG = 'https://images.pexels.com/photos/33343202/pexels-photo-33343202.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1200';

export default function PartnerLogin() {
  return (
    <LoginScreen
      bg={PARTNER_BG}
      badge="Accesso Partner"
      heroTitle="Fai crescere la tua attività."
      heroText="Hotel, ristoranti ed e-commerce: gestisci la tua presenza sulla piattaforma Sila Experiences e raggiungi nuovi visitatori."
      formTitle="Bentornato, Partner"
      formSubtitle="Accedi alla tua area stakeholder."
      showOAuth
      register={{ prefix: 'Non hai un account?', to: '/partner/registrati', label: 'Richiedi accesso Partner' }}
      testidPrefix="partner-login"
    />
  );
}
